var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-6 px-8"},[_c('h-header',{attrs:{"title":_vm.title}}),_c('AppointmentReports',{ref:"appointmentReportFilters"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }